import { Box, Typography } from "@mui/material";
import { BORDER, TEXT, TEXT_SOFT, fmt } from "../constants";

function toneColor(tone) {
  if (tone === "positive") return "#059669";
  if (tone === "warning") return "#d97706";
  if (tone === "danger") return "#dc2626";
  return TEXT;
}

function Kpi({ label, value, hint, delta, tone }) {
  return (
    <Box
      sx={{
        flex: "1 1 140px",
        minWidth: 132,
        p: 2,
        borderRadius: "12px",
        bgcolor: "#fff",
        border: `1px solid ${BORDER}`,
      }}
    >
      <Typography
        sx={{
          color: TEXT_SOFT,
          fontWeight: 700,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          fontSize: "0.65rem",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 700,
          color: TEXT,
          mt: 0.6,
          letterSpacing: "-0.03em",
          fontSize: { xs: 22, md: 26 },
          lineHeight: 1.1,
        }}
      >
        {value}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.6, minHeight: 18 }}>
        {delta != null && delta !== "" && (
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: toneColor(tone) }}>
            {delta}
          </Typography>
        )}
        {hint && (
          <Typography sx={{ fontSize: 12, color: TEXT_SOFT }}>
            {hint}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default function KpiStrip({ kpis }) {
  if (!kpis) return null;
  const mom = kpis.services.momPct;
  const momLabel =
    mom == null ? null : `${mom > 0 ? "+" : ""}${mom}% vs mes previo`;
  const momTone = mom == null ? "neutral" : mom >= 0 ? "positive" : "warning";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
      <Kpi
        label="Servicios históricos"
        value={fmt(kpis.services.total)}
        hint={`${fmt(kpis.services.completed)} completados`}
      />
      <Kpi
        label="Este mes"
        value={fmt(kpis.services.thisMonth)}
        delta={momLabel}
        tone={momTone}
        hint={`${fmt(kpis.services.lastMonth)} el anterior`}
      />
      <Kpi
        label="Tasa de cierre"
        value={`${kpis.services.completionRate}%`}
        hint={`${fmt(kpis.services.open)} abiertos`}
        tone={kpis.services.completionRate >= 70 ? "positive" : "warning"}
      />
      <Kpi
        label="Técnicos activos"
        value={fmt(kpis.technicians.active)}
        hint={`${fmt(kpis.technicians.workingThisMonth)} en campo este mes`}
      />
      <Kpi
        label="Clientes / sucursales"
        value={`${fmt(kpis.clients)} / ${fmt(kpis.branches)}`}
        hint="Cartera activa"
      />
      <Kpi
        label="Reportes de plaga"
        value={fmt(kpis.reports.total)}
        hint={`Nivel promedio ${kpis.reports.avgPestLevel}`}
        tone={kpis.reports.avgPestLevel >= 40 ? "warning" : "positive"}
      />
      <Kpi
        label="Certificados"
        value={fmt(kpis.certificates.total)}
        hint={`${fmt(kpis.certificates.thisMonth)} este mes`}
      />
      <Kpi
        label="Inventario bajo mínimo"
        value={fmt(kpis.inventory.lowStockCount)}
        hint={`${fmt(kpis.inventory.itemsCount)} ítems activos`}
        tone={kpis.inventory.lowStockCount > 0 ? "warning" : "positive"}
      />
    </Box>
  );
}
